import { render } from "./invoicesMenu.vue?vue&type=template&id=2b5f07d4"
import script from "./invoicesMenu.vue?vue&type=script&lang=js"
export * from "./invoicesMenu.vue?vue&type=script&lang=js"

import "./invoicesMenu.vue?vue&type=style&index=0&id=2b5f07d4&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__